import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

import { translate, keys as translationKeysSelector } from 'ggApp/modules/translator/selectors';
import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';

export const labelsPropTypes = {
    productName: PropTypes.string,
};

export default function withRentalPlanLabels(productSelector) {
    return (EnhancedComponent) => {
        const labelsSelector = createSelector(
            productSelector,
            activeStoreSelector,
            translationKeysSelector,
            (product, activeStore, translationKeys) => ({
                productName:
                    product.frontname ||
                    (product.contentful_record && product.contentful_record.frontname) ||
                    product.name,
                ...{
                    planDurationLabel:
                        translate(
                            translationKeys,
                            activeStore.activeLanguage,
                            'RENTAL_PLAN_FILTER_LABEL_SINGULAR',
                        ) || null,
                    planDurationPluralLabel:
                        translate(
                            translationKeys,
                            activeStore.activeLanguage,
                            'RENTAL_PLAN_FILTER_LABEL_PLURAL',
                        ) || null,
                },
            }),
        );

        @connect(
            createStructuredSelector({
                currentProduct: productSelector,
                labels: labelsSelector,
            }),
        )
        class RentalPlanLabelsHOC extends Component {
            render() {
                const {
                    // Prevent props forwarding to EnhancedComponent
                    currentProduct,
                    labels,
                    ...restProps
                } = this.props;

                return <EnhancedComponent labels={labels} {...restProps} />;
            }
        }

        RentalPlanLabelsHOC.propTypes = {
            labels: PropTypes.shape(labelsPropTypes),
            currentProduct: PropTypes.shape({}),
        };

        RentalPlanLabelsHOC.defaultProps = {
            labels: {
                productName: '',
            },
            currentProduct: {},
        };

        return RentalPlanLabelsHOC;
    };
}
